import(/* webpackMode: "eager" */ "/opt/buildhome/repo/frontend/src/app/global-error.tsx");
